import { render } from "./UofMMindfulMeditation.vue?vue&type=template&id=a9142814&scoped=true"
import script from "./UofMMindfulMeditation.vue?vue&type=script&lang=js"
export * from "./UofMMindfulMeditation.vue?vue&type=script&lang=js"

import "./UofMMindfulMeditation.vue?vue&type=style&index=0&id=a9142814&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9142814"]])

export default __exports__